/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import { useState, useEffect, useCallback } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { EditorState, ContentState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
// import CurrencyInput from 'react-currency-input-field'
import { ErrorField } from 'src/components/formik'

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

import InputField from 'src/components/formik/input-field'
import { SelectField } from 'src/components/formik/select'
// import Upload from 'src/components/upload'

import { useNotification } from 'src/contexts/notification.context'
import { agesData, subjectData, getImages } from 'src/tools'
import { getTopicsRequest, uploadEditorImage } from 'src/services/api.service'
import CropImage from './components/crop'

const PublicLessonSchema = Yup.object().shape({
  ages: Yup.array().of(Yup.string()).required('Required').min(1, 'Required'),
  subject_id: Yup.string().nullable('Required').required('Required'),
  // themes: Yup.array(),
  topic_ids: Yup.array().of(Yup.number()).nullable(),
  title: Yup.string().required('Required').min(3).max(60),
  description: Yup.string()
    .max(1800, 'Please enter no more than 1800 characters')
    .nullable(),
  status: Yup.string(),
  image: Yup.string(),
  // images: [],
  general_details: Yup.string().nullable(),
  details: Yup.string().nullable(),
  template: Yup.string().nullable(),
  // images: Yup.array().of(Yup.string()).nullable(),
})

const PublicLesson = ({ onSubmit, initialValues }) => {
  const { wrapCallback } = useNotification()

  const [uploadedCover, setUploadedCover] = useState(null)
  const [cover, setCover] = useState(null)

  const [topics, setTopics] = useState([])

  const [summary, setSummary] = useState(EditorState.createEmpty())
  const [details, setDetails] = useState(EditorState.createEmpty())

  const [images] = useState([])

  const formik = useFormik({
    initialValues,
    validationSchema: PublicLessonSchema,
    onSubmit: (data) => {
      const { image, ...rest } = data

      const form = rest // convertToFormData(rest)

      if (cover) {
        form.image = cover.preview
      }

      // if (images) {
      //   form.images = images;
      // }

      // form.general_details = (form.general_details || '').replace(/\/user_temp\//g, '/lessons/')
      // form.details = (form.details || '').replace(/\/user_temp\//g, '/lessons/')

      let imgs = getImages(form.general_details)
      imgs = imgs.map((x) => x.replace(`${process.env.REACT_APP_S3_HOST}/`, ''))

      let imgs2 = getImages(form.details)
      imgs2 = imgs2.map((x) =>
        x.replace(`${process.env.REACT_APP_S3_HOST}/`, ''),
      )

      form.images = [...imgs, ...imgs2]
      console.log('form', form)

      try {
        onSubmit(form, rest.status)
      } catch (error) {
        console.log('onSubmit', form, rest.status, error)
      }
    },
  })

  useEffect(() => {
    wrapCallback(async () => {
      if (initialValues.general_details) {
        const blocksFromHtml = htmlToDraft(initialValues.general_details)
        const { contentBlocks, entityMap } = blocksFromHtml
        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap,
        )
        const editorState = EditorState.createWithContent(contentState)
        setSummary(editorState)
      }

      if (initialValues.details) {
        const blocksFromHtml = htmlToDraft(initialValues.details)
        const { contentBlocks, entityMap } = blocksFromHtml
        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap,
        )
        const editorState = EditorState.createWithContent(contentState)
        setDetails(editorState)
      }
    })
  }, [])

  useEffect(() => {
    const fetch = async () => {
      if ((formik.values?.ages || [])?.length > 0 && formik.values.subject_id) {
        const result = await getTopicsRequest({
          ages: formik.values.ages,
          subject_id: formik.values.subject_id,
        })
        setTopics(result.data.items || [])
      }
    }
    fetch()
  }, [formik.values.ages, formik.values.subject_id])

  useEffect(() => {
    if (!initialValues.image) return

    setUploadedCover({
      preview: `${process.env.REACT_APP_S3_HOST}/${initialValues.image}`,
    })
  }, [initialValues.image])

  const handleChangeCover = (url) => {
    setCover({ preview: url })
  }

  const handleApplyCover = () => {
    // console.log('handleChangeCover', url);
    // setCover({ preview: url });
  }

  const handleRemoveUploadedCover = (e) => {
    e.preventDefault()
    setUploadedCover(null)
    formik.setFieldValue('image', null)
  }

  const handleSubmitDraft = () => {
    if (formik.isSubmitting) return

    formik.setFieldValue('status', 'draft')
    formik.submitForm()
  }

  const handleSubmitReview = () => {
    if (formik.isSubmitting) return

    formik.setFieldValue('status', 'in review')
    formik.submitForm()
  }

  // Editor
  const handleSummaryChange = (editorState) => {
    setSummary(editorState)
    formik.setFieldValue(
      'general_details',
      draftToHtml(convertToRaw(editorState.getCurrentContent())),
    )
  }

  const handleDetailsChange = (editorState) => {
    setDetails(editorState)
    formik.setFieldValue(
      'details',
      draftToHtml(convertToRaw(editorState.getCurrentContent())),
    )
  }

  const uploadSummaryCallback = useCallback(
    (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onloadend = async () => {
          try {
            const formData = { images: [reader.result] }

            const response = await uploadEditorImage(formData)

            const url = Array.isArray(response.data.items)
              ? response.data.items[0]
              : ''

            resolve({
              data: {
                link: `${process.env.REACT_APP_S3_HOST}/${url}`,
              },
            })
          } catch (error) {
            reject(error)
          }
        }

        reader.readAsDataURL(file)
      }),
    [images],
  )

  const configEditor = {
    image: {
      urlEnabled: false,
      uploadCallback: uploadSummaryCallback,
      previewImage: true,
      alt: { present: true, mandatory: false },
      inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
    },
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-sm-6 pb-30">
          <SelectField
            name="ages"
            label="Age"
            placeholder="Select age"
            options={agesData.map((x) => ({
              label: x.name,
              value: x.id.toString(),
            }))}
            formik={formik}
            isMulti
            closeMenuOnSelect={false}
          />
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6 pb-30">
          <SelectField
            name="subject_id"
            label="Subject"
            placeholder="Select subject"
            options={subjectData.map((x) => ({
              label: x.name,
              value: x.id.toString(),
            }))}
            formik={formik}
          />
        </div>
        <div className="col-lg-3 col-md-6 col-sm-6 pb-30">
          <SelectField
            name="topic_ids"
            label="Topics"
            placeholder="Select topics"
            options={topics.map((x) => ({
              label: x.name,
              value: x.id.toString(),
            }))}
            formik={formik}
            isMulti
            closeMenuOnSelect={false}
          />
        </div>
      </div>

      <div className="input-block">
        <div className="input-top">
          <label htmlFor="q-4">Title</label>
          <div className="tooltip">
            <i className="hb-ico tooltip-ico" />
            <div className="tooltip-info">
              <p>
                Please limit your title tag to 50–60 characters so it display
                properly.{' '}
              </p>
              <p>
                Title tag format: <b>primary Keyword - Secondary Keyword.</b>
              </p>
            </div>
          </div>
        </div>
        <InputField formik={formik} name="title">
          <input
            type="text"
            name="title"
            placeholder="Descriptive title here"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.title}
          />
          <span className="input-hint">
            <b>{formik.values.title?.length}</b>/60 characters
          </span>
        </InputField>
      </div>

      <div className="input-block">
        <div className="input-top">
          <label htmlFor="q-6">Subtitle</label>
          <div className="tooltip tooltip-img">
            <i className="hb-ico tooltip-ico" />
            <div className="tooltip-info">
              <img src="/account/img/lessons/summary.png" alt="" />
            </div>
          </div>
        </div>
        <InputField formik={formik} name="subtitle">
          <input
            type="text"
            name="subtitle"
            placeholder="Subtitle here"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.subtitle}
          />
          <span className="input-hint">
            <b>{formik.values.subtitle?.length}</b>/60 characters
          </span>
        </InputField>
      </div>

      <div className="input-block">
        <div className="input-top">
          <label htmlFor="q-6">Description</label>
          <div className="tooltip tooltip-img">
            <i className="hb-ico tooltip-ico" />
            <div className="tooltip-info">
              <img src="/account/img/lessons/description.png" alt="" />
            </div>
          </div>
        </div>
        <InputField formik={formik} name="description">
          <textarea
            name="description"
            placeholder="Please describe what subject/topic your printable worksheets cover"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.description}
          />
          <span className="input-hint">
            <b>{formik.values.description?.length}</b>/1800 characters
          </span>
        </InputField>
      </div>

      <div>
        <div className="input-block">
          <div className="input-top">
            <label htmlFor="q-6">Cover</label>
            <div className="tooltip tooltip-img">
              <i className="hb-ico tooltip-ico" />
              <div className="tooltip-info">
                <img src="/account/img/tooltip-img-min.png" alt="" />
              </div>
            </div>
          </div>
          {uploadedCover ? (
            <div className="thumb">
              <div className="thumb-inner">
                <img src={uploadedCover.preview} />
                <a
                  onClick={handleRemoveUploadedCover}
                  className="remove"
                  href="#"
                >
                  <img src="/account/img/remove.svg" alt="" />
                </a>
              </div>
            </div>
          ) : (
            <CropImage
              onChange={handleChangeCover}
              onApply={handleApplyCover}
            />
          )}

          <ErrorField formik={formik} name="image" />
        </div>
      </div>

      <div className="input-block">
        <div className="input-top">
          <label htmlFor="q-6">Summary Lesson</label>
          <div className="tooltip tooltip-img">
            <i className="hb-ico tooltip-ico" />
            <div className="tooltip-info">
              <img src="/account/img/lessons/lesson.png" alt="" />
            </div>
          </div>
        </div>
        <InputField formik={formik} name="description">
          <Editor
            editorState={summary}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={handleSummaryChange}
            toolbar={configEditor}
          />
        </InputField>
      </div>

      <div className="input-block">
        <div className="input-top">
          <label htmlFor="q-6">Lessons’ details</label>
          <div className="tooltip tooltip-img">
            <i className="hb-ico tooltip-ico" />
            <div className="tooltip-info">
              <img src="/account/img/lessons/lessons_d.png" alt="" />
            </div>
          </div>
        </div>
        <InputField formik={formik} name="description">
          <Editor
            editorState={details}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={handleDetailsChange}
            toolbar={configEditor}
          />
        </InputField>
      </div>

      {initialValues.status === 'draft' && (
        <div className="worksheetsHb-btn buttons-row">
          <button
            // disabled={formik.isSubmitting}
            type="button"
            onClick={handleSubmitDraft}
            className="second-btn"
          >
            {formik.isSubmitting && formik.values.status === 'draft'
              ? 'Saving...'
              : 'Save draft'}
          </button>

          <button
            // disabled={formik.isSubmitting}
            type="button"
            onClick={handleSubmitReview}
            className="primary-btn"
          >
            {formik.isSubmitting && formik.values.status === 'in review'
              ? 'Saving...'
              : 'Send to review'}
          </button>
        </div>
      )}

      {initialValues.status === 'in review' && (
        <div className="worksheetsHb-btn buttons-row">
          <button
            // disabled={formik.isSubmitting}
            type="button"
            onClick={handleSubmitReview}
            className="primary-btn"
          >
            {formik.isSubmitting && formik.values.status === 'in review'
              ? 'Saving...'
              : 'Save changes'}
          </button>
        </div>
      )}
    </form>
  )
}

export default PublicLesson
